
  import { Component, Prop } from 'vue-property-decorator'
  import { VSnackbar } from 'vuetify/lib'

  @Component
  export default class BaseMaterialSnackbar extends VSnackbar {
    @Prop({ type: Boolean, default: true }) private readonly dismissible!: boolean
    @Prop({ type: String, default: ''}) private readonly type!: string

    get classes(): {[key: string]: boolean} {
      return {
        ...(VSnackbar as any).options.computed.classes.call(this),
        'v-snackbar--material': true,
      }
    }
  }
